module.exports = __webpack_public_path__ + "img/Accessibility-settings_Es.bfac43db.png";